var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21.746 15.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 1.223,
    y2: 0.647,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0263b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.267,
    y1: 1.422,
    x2: 10.948,
    y2: 1.483,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d2131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd0339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1,
    y1: 1,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51b031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14893c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JCB",
    transform: "translate(-3.6 -2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M10.321,9.317v6.168a2.682,2.682,0,0,1-2.807,2.827c-1.166,0-2.333-.01-3.509.01-.336.01-.405-.1-.405-.415.02-1.581.01-3.163,0-4.734,0-.326.04-.405.405-.336a10.222,10.222,0,0,0,3.677.148A2.087,2.087,0,0,0,9.738,10.6c0-.791-.01-1.581.01-2.372.01-.277-.069-.376-.356-.366-.524.02-1.058.02-1.581,0-.306-.01-.4.1-.385.4.02.82.01,1.641,0,2.471a1.357,1.357,0,0,1-1.611,1.512,5.73,5.73,0,0,1-1.858-.435.455.455,0,0,1-.346-.494c.01-2.076,0-4.141.01-6.217a2.6,2.6,0,0,1,2.491-2.58c1.295-.04,2.6,0,3.9-.02.336-.01.316.178.316.405C10.321,5.037,10.321,7.182,10.321,9.317Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M79.52,12.565a7.978,7.978,0,0,0,5.673.534c.188-.04.3-.109.277-.316s0-.4-.01-.593c0-.059-.02-.119-.03-.217a6.64,6.64,0,0,1-2.105.554c-1.453.109-2.342-.692-2.244-2.056.079-1.058.949-1.69,2.2-1.611a5.78,5.78,0,0,1,2.115.554.247.247,0,0,0,.04-.079c.089-1,.1-1.008-.89-1.166a9.084,9.084,0,0,0-3.578.049,4.549,4.549,0,0,0-1.433.623c0-1.285-.079-2.54.02-3.766a2.566,2.566,0,0,1,2.58-2.263c1.235-.02,2.471.01,3.706-.01.3,0,.385.069.385.385-.01,4.28,0,8.56-.01,12.839a2.619,2.619,0,0,1-2.5,2.58c-1.295.04-2.6,0-3.9.02-.287,0-.316-.119-.316-.356C79.52,16.361,79.52,14.483,79.52,12.565Z",
    transform: "translate(-68.398 -0.274)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M160.107,10.448a5.7,5.7,0,0,0,.534-.247,1.1,1.1,0,0,0,.593-1.008,1.091,1.091,0,0,0-.633-.979,2.755,2.755,0,0,0-1.344-.237q-1.631-.015-3.262,0c-.3,0-.4-.079-.4-.385.02-.791-.01-1.581.01-2.372a2.663,2.663,0,0,1,2.629-2.609c1.236-.02,2.471.01,3.707-.01.316,0,.385.089.376.385-.01,4.28,0,8.56-.01,12.839a2.618,2.618,0,0,1-2.491,2.58c-1.295.04-2.6,0-3.9.02-.277,0-.316-.119-.316-.356.01-1.542.01-3.094,0-4.636,0-.316.109-.385.4-.376,1.206.01,2.4.01,3.608.01a2.957,2.957,0,0,0,1.018-.148,1.206,1.206,0,0,0,.919-1.2A1.189,1.189,0,0,0,160.6,10.6,2.116,2.116,0,0,0,160.107,10.448Z",
    transform: "translate(-136.976 -0.094)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M169.949,86.968c-.959,0-.949,0-.949-.959,0-.336.079-.474.435-.445.4.03.791-.01,1.176.01a.69.69,0,0,1,.712.712.674.674,0,0,1-.741.672C170.384,86.968,170.166,86.968,169.949,86.968Z",
    transform: "translate(-149.052 -74.854)",
    fill: "#14893c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M169.844,64.612a4.044,4.044,0,0,1,.692.01.611.611,0,0,1,.6.652.591.591,0,0,1-.623.623c-.247.02-.494.01-.741.01-.771,0-.751,0-.781-.781-.01-.4.089-.583.5-.524a2.053,2.053,0,0,0,.346.01Z",
    transform: "translate(-149.046 -55.958)",
    fill: "#14893c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.3fb53eded3128f8d32023014de1b0bd8.svg";
export { ForwardRef as ReactComponent };